const EXTERNAL_URL = {
  NZF: "https://www.nzf.org.nz/",
  NZF_CHILD: "https://www.nzfchildren.org.nz/",
  NZF_PREFIX: "nzf.org.nz",
  NZF_CHILD_PREFIX: "nzfchildren.org.nz",
};

export default EXTERNAL_URL;
